import React from "react";

import cn from "@/helpers/classNames";

export type TextAreaProps = React.ComponentPropsWithRef<"textarea">;

const TextArea = React.forwardRef<HTMLTextAreaElement, TextAreaProps>(
  ({ className, ...props }, ref) => {
    return (
      <textarea
        ref={ref}
        className={cn(
          "min-h-20 w-full resize-none appearance-none rounded-xs bg-background px-3 py-2 outline-0",
          "placeholder-gray-400",
          "disabled:cursor-not-allowed disabled:opacity-60",
          "focus:z-10",
          "border invalid:border-red-500",
          {
            "bg-gray-50 dark:bg-background": props.readOnly || props.disabled,
          },
          className,
        )}
        {...props}
      />
    );
  },
);

const TextAreaNamespace = Object.assign(TextArea, { id: "TextArea" });
export { TextAreaNamespace as TextArea };
